"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Input = _styledComponents["default"].input.withConfig({
  displayName: "input__Input",
  componentId: "sc-18efscm-0"
})(["width:100%;box-sizing:border-box;padding:14px 10px;background:#ffffff;border:1px solid rgba(202,204,208,0.85);border-radius:4px;color:#393f44;font-size:14px;&[type=\"number\"],&[type=\"date\"]{padding:11px 10px;}&.read-only{color:#c5c5c5;outline:none;}"]);

var _default = Input;
exports["default"] = _default;